if (!customElements.get('media-gallery')) {
  customElements.define(
    'media-gallery',
    class MediaGallery extends HTMLElement {
      constructor() {
        super();
        this.elements = {
          liveRegion: this.querySelector('[id^="GalleryStatus"]'),
          viewer: this.querySelector('[id^="GalleryViewer"]'),
          thumbnails: this.querySelector('[id^="GalleryThumbnails"]'),
        };
        this.mql = window.matchMedia('(min-width: 750px)');
        if (!this.elements.thumbnails) return;

        this.elements.viewer.addEventListener('slideChanged', debounce(this.onSlideChanged.bind(this), 500));
        this.elements.thumbnails.querySelectorAll('[data-target]').forEach((mediaToSwitch) => {
          mediaToSwitch
            .querySelector('button')
            .addEventListener('click', this.setActiveMedia.bind(this, mediaToSwitch.dataset.target, false));
        });
        if (this.dataset.desktopLayout.includes('thumbnail') && this.mql.matches) this.removeListSemantic();
      }

      onSlideChanged(event) {
        const thumbnail = this.elements.thumbnails.querySelector(
          `[data-target="${event.detail.currentElement.dataset.mediaId}"]`
        );
        this.setActiveThumbnail(thumbnail);
      }

    // Safe setActiveMedia — replace the existing function body with this
setActiveMedia(mediaId, prepend) {
  // Find the media element by media id
  const activeMedia = this.querySelector(`[data-media-id="${mediaId}"]`);

  // If no media for this variant — bail out safely
  if (!activeMedia) return;

  // Try to locate wrappers (some themes wrap items)
  const activeMediaWrapper = activeMedia.closest('.media-gallery__item') || activeMedia.closest('.media-item') || activeMedia.parentElement;
  const previousActiveMedia = this.querySelector('[data-media-id].is-active');
  const previousActiveMediaWrapper = previousActiveMedia ? (previousActiveMedia.closest('.media-gallery__item') || previousActiveMedia.closest('.media-item') || previousActiveMedia.parentElement) : null;

  // Remove active classes from previous
  if (previousActiveMedia) previousActiveMedia.classList.remove('is-active');
  if (previousActiveMediaWrapper) previousActiveMediaWrapper.classList.remove('is-active');

  // Add active class to newly selected media
  activeMedia.classList.add('is-active');
  if (activeMediaWrapper) activeMediaWrapper.classList.add('is-active');

  // Optional: scroll into view if this call intended to show/prepend
  try {
    if (activeMediaWrapper && prepend) {
      activeMediaWrapper.scrollIntoView({ behavior: 'smooth', block: 'nearest', inline: 'nearest' });
    }
  } catch (err) {
    // ignore scroll errors
  }
}


      setActiveThumbnail(thumbnail) {
        if (!this.elements.thumbnails || !thumbnail) return;

        this.elements.thumbnails
          .querySelectorAll('button')
          .forEach((element) => element.removeAttribute('aria-current'));
        thumbnail.querySelector('button').setAttribute('aria-current', true);
        if (this.elements.thumbnails.isSlideVisible(thumbnail, 10)) return;

        this.elements.thumbnails.slider.scrollTo({ left: thumbnail.offsetLeft });
      }

      announceLiveRegion(activeItem, position) {
        const image = activeItem.querySelector('.product__modal-opener--image img');
        if (!image) return;
        image.onload = () => {
          this.elements.liveRegion.setAttribute('aria-hidden', false);
          this.elements.liveRegion.innerHTML = window.accessibilityStrings.imageAvailable.replace('[index]', position);
          setTimeout(() => {
            this.elements.liveRegion.setAttribute('aria-hidden', true);
          }, 2000);
        };
        image.src = image.src;
      }

      playActiveMedia(activeItem) {
        window.pauseAllMedia();
        const deferredMedia = activeItem.querySelector('.deferred-media');
        if (deferredMedia) deferredMedia.loadContent(false);
      }

      preventStickyHeader() {
        this.stickyHeader = this.stickyHeader || document.querySelector('sticky-header');
        if (!this.stickyHeader) return;
        this.stickyHeader.dispatchEvent(new Event('preventHeaderReveal'));
      }

      removeListSemantic() {
        if (!this.elements.viewer.slider) return;
        this.elements.viewer.slider.setAttribute('role', 'presentation');
        this.elements.viewer.sliderItems.forEach((slide) => slide.setAttribute('role', 'presentation'));
      }
    }
  );
}
